import { Switch as AntSwitch } from "antd";
import { SwitchChangeEventHandler } from "antd/es/switch";
import { FormInputProps } from "./FormInput";

type SwitchProps = FormInputProps<boolean> & { label: string };

export default function Switch({ value, onChange, label }: SwitchProps) {
  return (
    <label>
      <AntSwitch
        checked={value}
        onChange={onChange as SwitchChangeEventHandler}
      />{" "}
      {label}
    </label>
  );
}
